export const getStoredAccessToken = () => {
  const raw = localStorage.getItem("access-token");
  if (!raw || raw === "undefined" || raw === "null") return null;

  try {
    const parsed = JSON.parse(raw);
    if (!parsed || parsed === "undefined") return null;
    return parsed;
  } catch {
    return raw;
  }
};

export const isAccessTokenExpired = () => {
  const token = getStoredAccessToken();
  if (!token || typeof token !== "string") return false;

  try {
    const payloadPart = token.split(".")[1];
    if (!payloadPart) return false;
    const normalized = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(normalized));
    if (!payload?.exp) return false;
    return Date.now() >= payload.exp * 1000;
  } catch {
    return false;
  }
};

export const isTokenExpiredPayload = (status, data) => {
  const text = `${data?.description || ""} ${data?.msg || ""} ${data?.message || ""}`.toLowerCase();
  return (
    (status === 401 || status === 402 || data?.status === false) &&
    text.includes("token has expired")
  );
};
